export const mouseOptions = ["Off", "zoom", "vscroll", "hscroll"];
export const measurementsOptions = ["SI", "English"];
export const themeOptions = ["lightmode", "darkmode"];
export const localStorageKeys = {
  language: "language",
  mouse: "mouseWheel",
  units: "unitSystem",
  theme: "thememode"
};

export const titleTextProps = { size: "medium", modifier: "medium" };
export const sectionTextProps = { size: "small", modifier: "default" };
export const optionGroupProps = { direction: "row", gap: "4px" };
export const labelSectionProps = { direction: "column", gap: "8px" };
